import script from "./ReferrerFormModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ReferrerFormModal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__